import React from 'react';

export default function Es() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path
        fill="#FFDA44"
        d="M0 9c0 1.102 0.198 2.156 0.56 3.131l8.44 0.783 8.44 -0.783a9 9 0 0 0 0.56 -3.13 9 9 0 0 0 -0.56 -3.13L9 5.087 0.56 5.87A9 9 0 0 0 0 9"
      />
      <path fill="#D80027" d="M17.44 5.87a9.003 9.003 0 0 0 -16.88 0zM0.56 12.13a9.003 9.003 0 0 0 16.88 0z" />
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h18v18H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
